exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gametips .cont[data-v-7a507169] {\n  z-index: 99999;\n  left: 0;\n  right: 0;\n  top: 3rem;\n  margin: auto;\n}\n.gametips .cont .head[data-v-7a507169] {\n  width: 10rem;\n}\n.gametips .cont .head.noLife[data-v-7a507169] {\n  width: 13.75rem;\n  margin-bottom: 0.88rem;\n}\n.gametips .cont .btn[data-v-7a507169] {\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 3.75rem;\n}\n.gametips .cont .btn p[data-v-7a507169] {\n  width: 7.5rem;\n}", ""]);

// exports
